import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faLock, faMailBulk, faPhone, faStar, faStarHalfAlt, faUnlock } from '@fortawesome/free-solid-svg-icons';
import userlogo from '../../../assets/images/user.png'
import Empty from '../../../assets/images/EmptyState.svg'
import FileSaver from 'file-saver';
import moment from 'moment';
import { applicationstatuslist } from '../../../action/jobs';
import Pagination from '../../Common/Pagination/Box';
import Modal from '../../Common/Modal'
import CandidateDetail from '../CandidateDetail'

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const List = ({ data, updateJobResponse, limit, setLimit, currentPage, setCurrentPage }) => {
    const [statusList, setStatusList] = useState([])
    const [showCandidateDetailModal, setShowCandidateDetailModal] = useState(false)
    useEffect(() => {
        applicationstatuslist().then((res) => {
            if (res.status) {
                setStatusList(res.result);
            }
        });
    }, [])
    const downloadResume = (input) => {
        const { RESUME_FILE, CANDIDATE_ID, SOURCE, RESUME_URL, CANDIDATE_NAME } = input;

        let fileUrl = '';
        let fileName = '';
        let extension = '';

        // Determine extension
        const getExtension = (filename) => {
            const parts = filename?.split('.');
            return parts?.length > 1 ? parts.pop() : 'pdf'; // fallback to 'pdf'
        };

        if (SOURCE === 'CANDIDATE') {
            if (RESUME_URL) {
                fileUrl = `${process.env.REACT_APP_BASE_URL}/candidate-resume/${RESUME_URL}`;
                extension = getExtension(RESUME_URL);
            } else {
                fileUrl = `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`;
                extension = getExtension(RESUME_FILE);
            }
        } else {
            fileUrl = `${process.env.REACT_APP_BASE_URL}/download/campus-resume/${RESUME_URL}`;
            extension = getExtension(RESUME_URL);
        }

        // Final filename with extension
        fileName = `jobzshala_${CANDIDATE_NAME.replace(/\s+/g, '')}.${extension}`;

        FileSaver.saveAs(fileUrl, fileName);
    };

    const downloadExcel = () => {
        const rows = data?.APPLICATIONS.map((item) => {
            const isStudent = item.SOURCE === 'STUDENT';

            return {
                Name: isStudent ? item.studentDetail.CANDIDATE_NAME : item.CANDIDATE_NAME,
                Phone: isStudent ? item.studentDetail.PHONENO : item.PHONENO,
                Email: isStudent ? item.studentDetail.EMAIL_ID : item.EMAIL_ID,
                AppliedOn: item.CREATED_ON ? new Date(item.CREATED_ON).toLocaleDateString() : '',
                ProfileSummary: isStudent ? item.studentDetail.PROFILE_SUMMARY : item.PROFILE_SUMMARY,
                Education: isStudent
                    ? `${item.studentDetail.COURSE_STREAM || ''} (${item.studentDetail.SPECIALIZATION || ''})`
                    : item.EDUCATION || '',
                Skills: item.SKILL?.map((s) => s.SKILL).join(", "),
                Experience: item.TOTAL_EXP_YEAR || item.TOTAL_EXP_MONTH
                    ? `${item.TOTAL_EXP_YEAR || 0} Yr ${item.TOTAL_EXP_MONTH || 0} Mo`
                    : '',
                CTC: item.CTC ? `₹${item.CTC.toLocaleString()}` : '',
                Industry: item.INDUSTRY || '',
                FunctionalArea: item.FUNCTIONAL_AREA || '',
                Location: item.CURRENT_LOCATION || '',
                CurrentDesignation: item.CURRENT_DESIGNATION || '',
                CurrentCompany: item.CURRENT_COMPANY || '',
                PreferredLocation: item.prefferedLocation?.map((loc) => loc.CITY).join(", "),
                Status: item.APPLICATION_STATUS_NAME || '',
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(fileData, "Applications.xlsx");
    };
    console.log(showCandidateDetailModal)
    return (
        <React.Fragment>
            <Modal
                onClose={() => {
                    setShowCandidateDetailModal(false)
                }}
                isOpen={showCandidateDetailModal}
            >
                <CandidateDetail
                    onClose={() => {
                        setShowCandidateDetailModal(false)
                    }}
                    data={showCandidateDetailModal}
                />

            </Modal>
            <div className={`${styles['order-first']} col-md-9`}>
                {data?.APPLICATIONS?.length > 0 &&
                    <div className={`${styles['filter-card']} mb-3`}>
                        <React.Fragment>
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label className={`${styles['label-ct']}`}>Show</label>
                                        <select className="form-select d-inline-block w-auto mx-2"
                                            value={limit}
                                            onChange={(e) => { setLimit(e.target.value) }}
                                        >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                        <span className={`${styles['label-ct']}`}>Records Per Page</span>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                    <Pagination
                                        limit={limit}
                                        totalCount={data?.count}
                                        range={3}
                                        currentPage={currentPage}
                                        onPageChange={(newPage) => { setCurrentPage(newPage) }}
                                    />
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-4">
                                    <div className='d-flex align-items-center'>
                                        <input type="checkbox" id="selectAll" className="form-check-input me-2" />
                                        <label htmlFor="selectAll" className={`${styles['label-ct']} me-4 mt-1`}>
                                            Select All
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-8 d-flex justify-content-end">
                                    <div className={`${styles['w-30']}`}>
                                        <button className={`${styles['edit-btn']} btn`} onClick={() => {
                                            downloadExcel()
                                        }}>
                                            Download Excel<FontAwesomeIcon icon={faDownload} className='ps-2' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>

                    </div>
                }
                {data?.APPLICATIONS.map((item) => {
                    const profileSections =
                        item.SOURCE === 'STUDENT' ?
                            [
                                {
                                    key: "profileSummary",
                                    condition: item.studentDetail.PROFILE_SUMMARY && item.studentDetail.PROFILE_SUMMARY?.length > 0,
                                    content: (
                                        <p className="mb-1">
                                            <strong>Profile Summary:</strong>{" "}
                                            {item.studentDetail.PROFILE_SUMMARY?.length > 100 ? (
                                                <>
                                                    {item.studentDetail.PROFILE_SUMMARY.substring(0, 100)}...
                                                    <span className="text-primary ms-1">| Full Profile</span>
                                                </>
                                            ) : (
                                                item.studentDetail.PROFILE_SUMMARY
                                            )}
                                        </p>
                                    ),
                                },
                                {
                                    key: "education",
                                    condition: item.EDUCATION,
                                    content: (
                                        <>
                                            <h6>Education</h6>
                                            <p>{item.studentDetail.COURSE_STREAM} ({item.studentDetail.SPECIALIZATION})</p>
                                        </>
                                    ),
                                },
                                {
                                    key: "skills",
                                    condition: Array.isArray(item.SKILL) && item.SKILL?.length > 0,
                                    content: (
                                        <>
                                            <h6>Skills</h6>
                                            <p>{item.SKILL.map((skill) => skill.SKILL).join(" | ")}</p>
                                        </>
                                    ),
                                },
                            ]
                            :
                            [
                                {
                                    key: "profileSummary",
                                    condition: item.PROFILE_SUMMARY && item.PROFILE_SUMMARY?.length > 0,
                                    content: (
                                        <p className="mb-1">
                                            <strong>Profile Summary:</strong>{" "}
                                            {item.PROFILE_SUMMARY?.length > 100 ? (
                                                <>
                                                    {item.PROFILE_SUMMARY.substring(0, 100)}...
                                                    <span className="text-primary ms-1">| Full Profile</span>
                                                </>
                                            ) : (
                                                item.PROFILE_SUMMARY
                                            )}
                                        </p>
                                    ),
                                },
                                {
                                    key: "experience",
                                    condition:
                                        (item.TOTAL_EXP_YEAR != null && item.TOTAL_EXP_YEAR !== 0) ||
                                        (item.TOTAL_EXP_MONTH != null && item.TOTAL_EXP_MONTH !== 0),
                                    content: (
                                        <p className="mb-1">
                                            <strong>Experience:</strong>{" "}
                                            {item.TOTAL_EXP_YEAR ? `${item.TOTAL_EXP_YEAR} Years` : ""}
                                            {item.TOTAL_EXP_YEAR && item.TOTAL_EXP_MONTH ? " " : ""}
                                            {item.TOTAL_EXP_MONTH ? `${item.TOTAL_EXP_MONTH} Months` : ""}
                                        </p>
                                    ),
                                },
                                {
                                    key: "salary",
                                    condition: item.CTC != null && item.CTC !== 0,
                                    content: (
                                        <p className="mb-1">
                                            <strong>Salary:</strong> ₹{item.CTC.toLocaleString()}
                                        </p>
                                    ),
                                },
                                {
                                    key: "education",
                                    condition: item.EDUCATION,
                                    content: (
                                        <>
                                            <h6>Education</h6>
                                            <p>{item.EDUCATION}</p>
                                        </>
                                    ),
                                },
                                {
                                    key: "industry",
                                    condition: item.INDUSTRY,
                                    content: <p className="mb-1"><strong>Industry:</strong> {item.INDUSTRY}</p>,
                                },
                                {
                                    key: "functionalArea",
                                    condition: item.FUNCTIONAL_AREA,
                                    content: <p className="mb-1"><strong>Functional Area:</strong> {item.FUNCTIONAL_AREA}</p>,
                                },
                                {
                                    key: "location",
                                    condition: item.CURRENT_LOCATION,
                                    content: <p className="mb-1"><strong>Location:</strong> {item.CURRENT_LOCATION}</p>,
                                },
                                {
                                    key: "currentDesignation",
                                    condition: item.CURRENT_DESIGNATION,
                                    content: (
                                        <>
                                            <h6>Current/ Latest</h6>
                                            <p>
                                                {item.CURRENT_DESIGNATION}
                                                {item.CURRENT_COMPANY ? ` at ${item.CURRENT_COMPANY}` : ""}
                                            </p>
                                        </>
                                    ),
                                },
                                {
                                    key: "preferredLocation",
                                    condition: Array.isArray(item.prefferedLocation) && item.prefferedLocation?.length > 0,
                                    content: (
                                        <>
                                            <h6>Preferred Location</h6>
                                            <p>{item.prefferedLocation.map((city) => city.CITY).join(", ")}</p>
                                        </>
                                    ),
                                },
                                {
                                    key: "skills",
                                    condition: Array.isArray(item.SKILL) && item.SKILL?.length > 0,
                                    content: (
                                        <>
                                            <h6>Skills</h6>
                                            <p>{item.SKILL.map((skill) => skill.SKILL).join(" | ")}</p>
                                        </>
                                    ),
                                },
                            ];

                    // Filter out sections that have valid conditions
                    const validSections = profileSections.filter(section => section.condition);

                    // Calculate the split index (30% for left, 70% for right)
                    const splitIndex = Math.max(1, Math.floor(validSections.length * 0.3));
                    const leftColumn = validSections.slice(0, splitIndex);
                    const rightColumn = validSections.slice(splitIndex);

                    return (
                        <div className={`${styles['details-card']} card mb-3`}>
                            <div className='row'>
                                <div className="col-md-5">

                                    <div className="d-flex">
                                        <div className={`${styles['userimg-icon']} me-3`}>
                                            <input type="checkbox" />
                                            <img src={item.SOURCE ? item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${item.CANDIDATE_ID}/${item.PROFILE_IMAGE}` : userlogo : userlogo} alt="profile" className="img-fluid" />
                                        </div>
                                        <div className={`${styles["profile-section"]}`}>
                                            <h5 className="mb-1">{item.SOURCE === 'STUDENT' ? item.studentDetail.CANDIDATE_NAME : item.CANDIDATE_NAME}</h5>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faPhone} />
                                                {item.SOURCE === 'STUDENT' ? item.studentDetail.PHONENO : item.PHONENO}
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faMailBulk} />
                                                {item.SOURCE === 'STUDENT' ? item.studentDetail.EMAIL_ID : item.EMAIL_ID}
                                            </p>
                                        </div>
                                    </div>
                                    <button className={`${styles["search-btn"]} btn`}
                                        onClick={() => {
                                            setShowCandidateDetailModal(item)
                                        }}
                                    >
                                        View Full Profile
                                    </button>
                                    <hr />
                                    <div className="row mb-3">
                                        <div className={`${styles["profile-details"]}`}>
                                            {leftColumn.map(section => section.content)}
                                        </div>
                                    </div>
                                </div>

                                <div className={`${styles["profile-details"]} border-start col-md-4`}>
                                    {rightColumn.map(section => section.content)}
                                </div>
                                <div className={`${styles['profile-details']} border-start col-md-3`}>
                                    <div className="card p-3 d-flex justify-content-between h-100 text-start border-0">

                                        <div className='d-flex flex-column'>
                                            <p className={`${styles['normal-text']} mb-2`}>Applied on {moment(item.CREATED_ON).format("DD MMM, YYYY")}</p>
                                            <button className={`${styles['applied-btn']} btn mb-2`}>{item.APPLICATION_STATUS_NAME}</button>

                                            <button className={`${styles['search-btn']} btn mb-1`}
                                                onClick={() => {
                                                    downloadResume(item)
                                                }}
                                            >Download Resume</button>
                                            {/* 
                                            <div className="mb-3">
                                                    <span onMouseOver={() => { setTemporaryRating(item.CANDIDATE_ID, 1) }} onMouseLeave={() => { unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { sendCandidateRating(item.CANDIDATE_ID, 1) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null ? { color: '#ffc300' } : (item.rating >= 0) ? { color: '#ffc300' } : {}} ></i></span>
                                                    <span onMouseOver={() => { setTemporaryRating(item.CANDIDATE_ID, 2) }} onMouseLeave={() => { unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { sendCandidateRating(item.CANDIDATE_ID, 2) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 2 ? { color: '#ffc300' } : (item.rating >= 2) ? { color: '#ffc300' } : {}}></i> </span>
                                                    <span onMouseOver={() => { setTemporaryRating(item.CANDIDATE_ID, 3) }} onMouseLeave={() => { unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { sendCandidateRating(item.CANDIDATE_ID, 3) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 3 ? { color: '#ffc300' } : (item.rating >= 3) ? { color: '#ffc300' } : {}}></i> </span>
                                                    <span onMouseOver={() => { setTemporaryRating(item.CANDIDATE_ID, 4) }} onMouseLeave={() => { unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { sendCandidateRating(item.CANDIDATE_ID, 4) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 4 ? { color: '#ffc300' } : (item.rating >= 4) ? { color: '#ffc300' } : {}}></i> </span>
                                                    <span onMouseOver={() => { setTemporaryRating(item.CANDIDATE_ID, 5) }} onMouseLeave={() => { unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { sendCandidateRating(item.CANDIDATE_ID, 5) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 5 ? { color: '#ffc300' } : (item.rating >= 5) ? { color: '#ffc300' } : {}}></i> </span>

                                            </div> */}
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <div className="mb-3">
                                                <select
                                                    className="form-select"
                                                    onChange={(e) => updateJobResponse(item, e.target.value)}
                                                >
                                                    <option value="Applied - Matching">Applied - Matching</option>
                                                    {statusList.map((i) => (
                                                        <option key={i.STATUS_ID} value={i.STATUS_ID}>
                                                            {i.STATUS_NAME}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <button className={`${styles['reject-btn']} btn`}
                                                onClick={() => {
                                                    updateJobResponse(item, 5);
                                                }}
                                            >{item.APPLICATION_STATUS == 5
                                                ? "Rejected"
                                                : "Reject"}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
                {
                    data?.APPLICATIONS?.length === 0 && (
                        <div className={`${styles['details-card']} card mb-3 d-flex justify-content-center align-items-center text-center`}>
                            <div className="row w-100 d-flex justify-content-center">
                                <div className="col-md-6 d-flex flex-column align-items-center">
                                    <img
                                        width={150}
                                        height={150}
                                        src={Empty}
                                        alt="No profiles found"
                                    />
                                    <h4 className="mb-1">No profiles found</h4>
                                    <p>Please modify your search and expand your search criteria.</p>
                                    <button className={`${styles["search-btn"]} btn w-50 mt-2 mb-5`}>
                                        Modify Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

        </React.Fragment>

    )
}

export default List